import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {ThemeControllerContextProps} from '../../../../../../libs/shared/ui/src/theme/themeControllerContext';

export const ThemeControllerDropdownItem: FC<ThemeControllerContextProps> = ({
  shouldRenderThemeOverrideUi,
  isLightThemeOverride,
  onToggleLightThemeOverride,
}) => {
  if (!shouldRenderThemeOverrideUi) {
    return null;
  }

  const themeText = isLightThemeOverride ? (
    <Trans id="message-actions-view-in-dark-theme">View in dark theme</Trans>
  ) : (
    <Trans id="message-actions-view-in-light-theme">View in light theme</Trans>
  );

  return (
    <DropdownItem onSelect={() => onToggleLightThemeOverride(!isLightThemeOverride)}>
      <DropdownItemIcon label={themeText} iconSize={16} iconName="lightThemeSmall" />
      <DropdownItemContent>{themeText}</DropdownItemContent>
    </DropdownItem>
  );
};
